'use client'

import { ProductThumbnail } from '@/General/ProductThumbnail'
import Link from 'next/link'
import { tracking } from '@/tracking'

export type TopSellerItem = {
  id?: number | null
  name?: string | null
  url?: string | null
  imageUrl?: string | null
  isOnSale?: boolean
}

export function BestSellingMagicClient({ items }: { items: TopSellerItem[] }) {
  const onTopSellerClick = (item: TopSellerItem, rank: number) => {
    tracking.track('Clicked top seller', {
      'Top sellers product ID': item.id ?? '',
      'Top sellers product name': item.name ?? '',
      'Top sellers rank': rank,
    })
  }

  return (
    <div className="bg-gray-100 md:rounded-md p-4 md:p-3">
      <h2 className="text-lg md:text-2xl text-center font-medium border-y-2 mb-4 py-2 border-vi-gray">
        Our Best Selling Magic Tricks
      </h2>
      <ol className="pl-1 space-y-3">
        {items.map((topSeller, index) => {
          const rank = index + 1
          return (
            <li
              key={topSeller.id || index}
              className="list-none"
              data-productid={topSeller.id}
              data-productname={topSeller.name}
              data-rank={rank}
            >
              {topSeller.url ? (
                <Link
                  href={topSeller.url}
                  prefetch={false}
                  className="group flex items-start"
                  onClick={() => onTopSellerClick(topSeller, rank)}
                >
                  {topSeller.imageUrl && (
                    <div className="mr-2 ml-0 shrink-0">
                      <ProductThumbnail
                        src={`${topSeller.imageUrl}?format=auto&w=35&dpr=2`}
                        alt={topSeller.name || ''}
                        className="w-9 h-12 object-cover rounded-md"
                        loading="lazy"
                        fetchPriority="low"
                      />
                    </div>
                  )}
                  <div className="flex-1 min-w-0">
                    {rank}.{' '}
                    <span className="no-underline! group-hover:underline! text-vi-red">
                      {topSeller.name}
                    </span>
                    {topSeller.isOnSale && (
                      <span className="ml-2 inline-block rounded bg-green-600 px-1.5 py-0.5 text-[10px] font-semibold tracking-wide text-white">
                        SALE
                      </span>
                    )}
                  </div>
                </Link>
              ) : (
                <div className="flex items-start">
                  <div className="flex-1 min-w-0">
                    {rank}. <span>{topSeller.name}</span>
                    {topSeller.isOnSale && (
                      <span className="ml-2 inline-block rounded bg-green-600 px-1.5 py-0.5 text-[10px] font-semibold tracking-wide text-white">
                        SALE
                      </span>
                    )}
                  </div>
                </div>
              )}
            </li>
          )
        })}
      </ol>
    </div>
  )
}
